import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { OrderModule } from 'ngx-order-pipe';
import { DataTablesModule } from "angular-datatables";
import { NgSelectModule } from '@ng-select/ng-select';
// import { NgOptionHighlightModule } from '@ng-select/ng-option-highlight';
import { DatePipe, APP_BASE_HREF } from '@angular/common';
// import { NgSelect2Module } from 'ng-select2';

import { ConfirmationDialogService } from 'shared/components/confirmation-dialog/confirmation-dialog.service';
import { MsalService } from 'msal';
import { SharedModule } from 'shared/shared.module';
import { CoreModule } from 'core/core.module';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app-root/app.component';
import { environment } from '../environments/environment';
import { AuthenticationService } from 'core/authentication.service';
import { NgSessionStorage } from 'core/utils/ng-storage.service';
import { DashboardModule } from './dashboard.module';

let AuthServiceFactory = () => {
  const authConfig = {
    clientId: environment.adClientId,
    authority: environment.adAauthority,
    redirectUri: environment.adRedirectUrl,
    postLogoutRedirectUri: environment.adPostLogoutRedirectUri
  }
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set(environment.servicePartnerDataURL, environment.apiConfig.partnerApiscope);
  protectedResourceMap.set(environment.serviceWorkflowURL, environment.apiConfig.workflowApiScope);
  protectedResourceMap.set(environment.serviceDataIntakeURL, environment.apiConfig.dataIntakeApiscope);
  return new AuthenticationService(authConfig, protectedResourceMap);
};

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    NgbModule,
    CoreModule,
    OrderModule,
    DataTablesModule,
    FontAwesomeModule,
    ToastrModule.forRoot({
      timeOut: 50000,
      positionClass: 'toast-top-center',
      preventDuplicates: true,
    }),
    SharedModule,
    NgSelectModule,
    // NgOptionHighlightModule,
    // NgSelect2Module,
    AppRoutingModule
  ],

  providers: [
    MsalService,
    {
      provide: AuthenticationService,
      useFactory: AuthServiceFactory
    },
    { provide: APP_BASE_HREF, useValue: '/' },
    ConfirmationDialogService,
    NgSessionStorage,
    DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule { }

